import React, { useEffect, useState } from "react";
import { FaBuilding, FaPersonBooth } from "react-icons/fa";
import Popup from "../../../../../components/Popup";
import collaboratorServices from "../../../../../services/admFin/collaboratorServices";
import { PaymentsPopUp } from "./PaymentsPopUp";

import "./styles.css";

export function CollaboratorInfoPopUp(props) {
    const [visibility, setVisibility] = useState(false);
    const [payments, setPayments] = useState([]);
    const getPayments = async () =>  {
        try {
            const response = await collaboratorServices.getPayments(props.collaborator.id);
            setPayments(response.data);
        } catch(e) {
            alert("Não foi possível recuperar os pagamentos do colaborador");
        }
    }
    useEffect(() => {
        if(props.collaborator && props.collaborator.id) 
            getPayments();
    }, [props.collaborator]);
    
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={"Colaborador"}
            icon={<FaPersonBooth />}
        >
            <div className="records-element-info">
                
                {props.collaborator && props.collaborator.foto ? 
                    <img className="collaborator-info-image" src={props.collaborator.foto} alt="Foto do Colaborador"/>
                    :
                    <div className={'photo-preview-collaborator-info'} />
                }
                <p><b>Nome: </b>{props.collaborator && props.collaborator.nome? props.collaborator.nome : ""}</p>
                <p><b>CPF: </b>{props.collaborator && props.collaborator.documento ? props.collaborator.documento : ""}</p>
                <p><b>Data de Admissão: </b>{props.collaborator && props.collaborator.data_admissao ? props.collaborator.data_admissao : ""}</p>
                <p><b>Cargo: </b>{props.collaborator && props.collaborator.cargo ? props.collaborator.cargo : ""}</p>
                <p><b>Salário: </b>{props.collaborator && props.collaborator.salario ? props.collaborator.salario : ""}</p>
                {
                    props.collaborator && props.collaborator.inativo ?
                        <p><b>Data de Demissão: </b>{props.collaborator && props.collaborator.data_demissao ? props.collaborator.data_demissao : ""}</p>
                        :
                        null
                }
                <p><b>Empresas:</b></p>
                {
                    !props.collaborator.empresas || props.collaborator.empresas.length === 0 ?
                        null
                        :
                        props.collaborator.empresas.map(empresa => {
                            return (
                                <p key={empresa.id}>{empresa.nome}</p>
                            )
                        })
                }
                <PaymentsPopUp
                    visibility={visibility}
                    setVisibility={setVisibility}
                    id={props.collaborator.id}
                    name={props.collaborator.nome}
                    payments={payments}
                    getPayments={getPayments}
                />
                <button onClick={()=>setVisibility(true)}>
                    Pagamentos
                </button>
            </div>
        </Popup>
    )
}